import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ComparisonCSName from "../ComparisonCSName";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultText from "../ResultText";
import ResultView from "../../../components/ResultView";

export function ST7({data, message_key}) {
    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const BridgeList = ({bridges}) => {
    if (!bridges || bridges.length === 0) return null
    return (
        <ResultText>
            Internal Bridge Cross Section is defined at the following bridge structures.
            <EmptyLine />
            <ComparisonCSName csNameList={bridges.map(b => ({csName: b, csNameVal: b}))} />
            <EmptyLine />
        </ResultText>
    )
}

const Description = ({row, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.ST08.error_id: {
            return (
                <>
                    <BridgeList bridges={row?.list_bridges} />
                    <ResultText>
                        The topography (Station/Elevation data) of the following Internal Bridge Cross Sections is different than the bounding cross sections.
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(30)}}>IB Cross Section</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(30)}}>Bounding Cross Section</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{r.cross_section}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left'}}>{r.bounding_cross_section}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.ST11.error_id: {
            return (
                <>
                    <BridgeList bridges={row?.list_bridges} />
                    <ResultText>
                        The Manning’s n value of the following Internal Bridge Cross Sections is different than the bounding cross sections.
                    </ResultText>
                    <ResultText>
                        {row?.data?.map(r => renderMannData(r, globalVariables))}
                        <br/>
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

// Same chunked Manning's n comparison table layout as C6 (compare_mannings),
// but the row labels are the bounding XS and the IB XS instead of two plans.
const renderMannData = (row, globalVars) => {
    const tables = []
    const chunkSize = 7
    for (let i = 0; i < row?.matched_table?.length; i += chunkSize) {
        const match_table_data = row?.matched_table?.slice(i, i + chunkSize)
        tables.push((
            <ResultTable>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(21)}}>
                            {(i === 0) && (<ComparisonCSName csName={row.cross_section} />)}
                        </ResultHeaderCell>
                        {
                            match_table_data.map((r) => (
                                <ResultHeaderCell colSpan={2}>
                                    <b>{r?.number ? `n#${r.number}` : `-`}</b>
                                </ResultHeaderCell>
                            ))
                        }
                    </ResultRow>
                </ResultHeader>

                <ResultBody>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(21)}}>
                            <b>{row?.bounding_cross_section || 'Bounding'}</b>
                        </ResultHeaderCell>
                        {
                            match_table_data.map(y => {
                                let bgColor = ''
                                if (row?.base_chn_stations?.includes(y?.base_station))
                                    bgColor = '#C0FFC8'
                                return (
                                    <>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{y?.base_station?.toString() || '-'}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', backgroundColor: bgColor}}>{y?.base_val || '-'}</ResultBodyCell>
                                    </>
                                )
                            })
                        }
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(21)}}>
                            <b>{row?.cross_section || 'IB'}</b>
                        </ResultHeaderCell>
                        {
                            match_table_data.map(y => {
                                let bgColor = ''
                                if (row?.cmp_chn_stations?.includes(y?.cmp_station))
                                    bgColor = '#C0FFC8'
                                return (
                                    <>
                                        <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(5)}}>{ResultCellHighlight(y?.base_station?.toString() || '-', y?.cmp_station?.toString() || '-')}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(5), backgroundColor: bgColor}}>{ResultCellHighlight(y?.base_val || '-', y?.cmp_val || '-')}</ResultBodyCell>
                                    </>
                                )
                            })
                        }
                    </ResultRow>
                </ResultBody>
            </ResultTable>
        ))
    }

    return (
        <div style={{overflowX: 'auto', paddingBottom: 8, overflowY: 'auto'}}>
            {tables}
        </div>
    )
}
